import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserFavoriteItem } from "src/models";
import { ProfileData, ProfileDataAction } from "src/store";
import LazyLoad from "vanilla-lazyload";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";
import { Plus } from "src/components/svg";

export const SportSearchItem: React.FC<UserFavoriteItem> = (item) => {

    const dispatch = useDispatch();
    const data: ProfileData = useSelector((state: any) => state.ProfileDataState);
    const { actionLoading, editingFavorite } = data.favorites;

    const onAdd = () => dispatch(ProfileDataAction.addFavorite(item));

    useEffect(() => {
        const lazyload = new LazyLoad({
            elements_selector: `.lazy[data-name='${item.sport}']`,
            callback_error: (element: HTMLElement) => {
                const placeholder = element.getAttribute("data-placeholder");
                if (placeholder) element.setAttribute("src", placeholder);
            }
        });

        lazyload.update();

    }, [item]);


    return (
        <div className="d-flex sport-item">
            <img alt=""
                width={32} height={32}
                data-src={item.icon}
                data-placeholder={phPackage}
                data-name={item.sport}
                src={phPackage}
                className="logo lazy" />
            <span>{item.sport}</span>
            <button disabled={actionLoading} onClick={onAdd} className="btn btn-edit-favorite"><Plus />{editingFavorite?._texts.add}</button>
        </div>
    );
};